<div class="js-canvas">
    <table class="table">
        <caption class="sr-only"></caption>
        <thead></thead>
        <tbody aria-live="polite"></tbody>
        <tfoot></tfoot>
    </table>
</div>
<div data-hook="infoContainer" class="info-container"></div>